import React from 'react';

export const NavigationIcon = ({ type }: { type: 'prev' | 'next' }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        style={{
            transform: type === 'next' ? 'rotate(180deg)' : 'rotate(0deg)',
        }}
    >
        <g clipPath="url(#clip0_2269_6327)">
            <path
                d="M9.03552 11.29L4.09602 6.3505C4.00466 6.25549 3.95363 6.12881 3.95363 5.997C3.95363 5.86519 4.00466 5.73851 4.09602 5.6435L9.03302 0.707L8.32602 -3.10132e-08L3.38902 4.9365C3.11651 5.22243 2.9645 5.60226 2.9645 5.99725C2.9645 6.39224 3.11651 6.77207 3.38902 7.058L8.32852 11.997L9.03552 11.29Z"
                fill="currentColor"
            />
        </g>
        <defs>
            <clipPath id="clip0_2269_6327">
                <rect width="12" height="12" fill="white" transform="translate(0 12) rotate(-90)" />
            </clipPath>
        </defs>
    </svg>
);
